import { join } from 'node:path';
import z from 'zod';

export const GIT_IGNORED_DIR = '.wix';
export const ENV_FILE_NAME = '.env.local';
export const BACKEND_WORKER_COMPONENT_ID =
  'ed5f3d0e-7b79-4717-9c00-c4cd7bbbe906';

export const wixAstroConfigSchema = z
  .object({
    $schema: z.string().optional(),
    appId: z.string().uuid(),
    siteId: z.string().uuid(),
  })
  .strict();

export type WixAstroConfig = z.infer<typeof wixAstroConfigSchema>;

export const buildMetadataSchema = z.object({
  appManifestPath: z.string(),
  outDir: z.string(),
  clientDir: z.string(),
  serverDir: z.string().optional(),
});

export type BuildMetadata = z.infer<typeof buildMetadataSchema>;

const deploymentTopologyEnvironmentSchema = z.object({
  id: z.string().describe('Unique ARM tag identifier'),
  site: z
    .object({
      main: z.string().url().describe('Main site URL'),
    })
    .describe('Site topology details')
    .required(),
  dashboard: z
    .object({
      main: z
        .string()
        .url()
        .describe('Main dashboard URL (link to a business manager dashboard)'),
    })
    .describe('Optional dashboard topology details')
    .optional(),
});

const deploymentTopologyEnvironmentTypeSchema = z.enum([
  'production',
  'preview',
  'development',
]);

export type DeploymentTopologyEnvironmentType = z.infer<
  typeof deploymentTopologyEnvironmentTypeSchema
>;

export const deploymentTopologySchema = z.record(
  deploymentTopologyEnvironmentTypeSchema,
  deploymentTopologyEnvironmentSchema
);

export type DeploymentTopology = z.infer<typeof deploymentTopologySchema>;

export function getBuildManifestPath(projectFolder: string) {
  return join(projectFolder, GIT_IGNORED_DIR, 'build-metadata.json');
}

export function getDeploymentTopologyPath(projectFolder: string) {
  return join(projectFolder, GIT_IGNORED_DIR, 'topology.json');
}

export function getEnvFilePath(projectFolder: string) {
  return join(projectFolder, ENV_FILE_NAME);
}

export function getExtensionPath(projectFolder: string, extensionPath: string) {
  return join(projectFolder, 'src', 'extensions', extensionPath);
}
